import React, { type ComponentProps, type ReactNode } from 'react';
import { type TextStyle } from 'react-native';

import { theme } from '@garnish/constants';
import { LabelText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductCardV2ProductDetail = (props: ProductCardV2ProductDetailProps) => {
  const { children, palette = 'light-neutral', sizeMatch = DEFAULT_SIZE_MATCH } = props;

  // ─── Styles ──────────────────────────────────────────────────────────

  const textStyles = paletteStyles[palette];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <LabelText sizeMatch={sizeMatch} style={textStyles}>
      {children}
    </LabelText>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const DEFAULT_SIZE_MATCH: SizeMatch = ['14'];

// ─── Styles ──────────────────────────────────────────────────────────────────

const paletteStyles: Record<ProductCardV2ProductDetailPalette, TextStyle> = {
  'dark-kale': {
    color: theme.colors.DARK_KALE,
  },
  'light-neutral': {
    color: theme.colors['NEUTRAL_1.5'],
  },
};

// ─── Types ───────────────────────────────────────────────────────────────────

type ProductCardV2ProductDetailProps = {
  children: ReactNode;
  palette?: ProductCardV2ProductDetailPalette;
  sizeMatch?: SizeMatch;
};

type ProductCardV2ProductDetailPalette = 'dark-kale' | 'light-neutral';

type SizeMatch = ComponentProps<typeof LabelText>['sizeMatch'];
